import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import isAuthorized from 'User/utils/isAuthorized';
import roles from 'User/constants/roles';
import isAllowedToExamineMeasure from 'User/utils/isAllowedToExamineMeasure';
import measures from 'Measure/constants/measures';
import Button from 'Common/components/Button';

const DriverLicenseControlOverviewMainButton = ({ driverLicenseControl }) => {
    const userId = useSelector(state => state.user.id);

    const driverLicense = driverLicenseControl.driverLicense;
    const nextCheck = driverLicense.nextCheck;

    const isExaminer =
        isAuthorized([roles.MANAGER]) ||
        (isAllowedToExamineMeasure(measures.DRIVER_LICENSE) &&
            driverLicenseControl.examiners.findIndex(
                examiner => examiner.id === userId,
            ) !== -1);

    if (
        driverLicenseControl.isActive &&
        !driverLicense.isLost &&
        !driverLicense.isExpired &&
        nextCheck.isInVerificationPeriod &&
        !nextCheck.isCompleted
    ) {
        if (driverLicense.isUsingDirectControlMethod) {
            if (nextCheck.directProcedure.isPendingExaminerVerification) {
                if (isExaminer) {
                    return (
                        <Button
                            to={`/measures/vehicles/driver-license/examiner/direct-check/${driverLicenseControl.id}`}
                        >
                            Kontrolle starten
                        </Button>
                    );
                } else {
                    return (
                        <Button
                            type="button"
                            tooltip="Bitte legen Sie Ihren Führerschein einen der aufgeführten Prüfer vor"
                            disabled
                        >
                            Kontrolle bestätigen
                        </Button>
                    );
                }
            }

            if (nextCheck.directProcedure.isPendingEmployeeConfirmation) {
                if (isExaminer) {
                    return (
                        <Button
                            type="button"
                            tooltip="Vom Prüfer bereits absolviert"
                            disabled
                        >
                            Kontrolle bestätigen
                        </Button>
                    );
                } else {
                    return (
                        <Button to="/measures/vehicles/driver-license/employee/direct-check">
                            Kontrolle bestätigen
                        </Button>
                    );
                }
            }
        }

        if (driverLicense.isUsingDistanceControlMethod) {
            if (nextCheck.distanceProcedure.isPendingEmployeeFileUpload) {
                if (isExaminer) {
                    return (
                        <Button
                            type="button"
                            tooltip="Führerscheinfotos  seitens des Mitarbeiters noch nicht bereitgestellt"
                            disabled
                        >
                            Abgleich Starten
                        </Button>
                    );
                } else {
                    return (
                        <Button to="/measures/vehicles/driver-license/employee/distance-check">
                            Fotos bereitstellen
                        </Button>
                    );
                }
            }

            if (nextCheck.distanceProcedure.isPendingExaminerVerification) {
                if (isExaminer) {
                    return (
                        <Button
                            to={`/measures/vehicles/driver-license/examiner/distance-check/${driverLicenseControl.id}`}
                        >
                            Abgleich Starten
                        </Button>
                    );
                } else {
                    return (
                        <Button
                            type="button"
                            tooltip="Führerscheinfotos befinden sich im Abgleich"
                            disabled
                        >
                            Fotos bereitstellen
                        </Button>
                    );
                }
            }
        }
    }

    return null;
};

DriverLicenseControlOverviewMainButton.propTypes = {
    driverLicenseControl: PropTypes.object.isRequired,
};

export default DriverLicenseControlOverviewMainButton;
